import { EIntegracoesAPIEnum } from "@/features/financas/views/Integracoes/@types/IntegracoesAPIEnum";
import { TKeyValue } from "../../../services/PainelDeIntegracaoesGateway";
import { IDefaultHttpFinancasResponse } from "@/core/@types/types";

export type TObterWebserviceResponse = {
  API?: number;
  Alterdata?: Record<string, unknown>;
  ApiAdyen?: Record<string, unknown>;
  ApiC6Pay?: Record<string, unknown>;
  ApiCRMBonus?: Record<string, unknown>;
  ApiPayGo?: Record<string, unknown>;
  ApiCigam?: Record<string, unknown>;
  ApiCigamCMV?: Record<string, unknown>;
  ApiEVO?: Record<string, unknown>;
  ApiIFoodRest?: Record<string, unknown>;
  ApiPdvCarMob?: Record<string, unknown>;
  ApiPdvColibriNovo?: Record<string, unknown>;
  ApiPdvConsoft?: Record<string, unknown>;
  ApiPdvGcom?: Record<string, unknown>;
  ApiSystemFarma?: Record<string, unknown>;
  ApiTecnospeed?: Record<string, unknown>;
  ApiVarejoFacilNFe?: Record<string, unknown>;
  ApiVelocePOS?: Record<string, unknown>;
  BoticarioWebhook?: Record<string, unknown>;
  CertificateFile?: string;
  ClJoias?: Record<string, unknown>;
  DeliveryDireto?: Record<string, unknown>;
  EComanda?: Record<string, unknown>;
  EcleticaPdv?: Record<string, unknown>;
  Empresa?: Record<string, unknown>;
  F360PublicAPI?: Record<string, unknown>;
  FitCard?: Record<string, unknown>;
  FollowUp?: Record<string, unknown>;
  LinkedGourmet: Record<string, unknown>;
  LinxDegust?: Record<string, unknown>;
  LinxDegustV2?: Record<string, unknown>;
  LinxDegustV3?: Record<string, unknown>;
  LinxErp?: Record<string, unknown>;
  MetaDataRede?: Record<string, unknown>;
  MetadataGestaoClick?: Record<string, unknown>;
  MetadataIfood?: Record<string, unknown>;
  MetadataMVarandas?: Record<string, unknown>;
  OperadoraAdiq?: Record<string, unknown>;
  OperadoraAmeDigital?: Record<string, unknown>;
  OperadoraSoftcred?: Record<string, unknown>;
  PDVDataSystem?: Record<string, unknown>;
  PdvAlloc?: Record<string, unknown>;
  PdvAmmo?: Record<string, unknown>;
  PdvAvec?: Record<string, unknown>;
  PdvBling?: Record<string, unknown>;
  PdvBusinessShop?: Record<string, unknown>;
  PdvCPlug?: Record<string, unknown>;
  PdvCake?: Record<string, unknown>;
  PdvCissLive?: Record<string, unknown>;
  PdvColibri?: Record<string, unknown>;
  PdvGilbarco?: Record<string, unknown>;
  PdvLadfood?: Record<string, unknown>;
  PdvMitryus?: Record<string, unknown>;
  PdvMoncloa: Record<string, unknown>;
  PdvNet?: Record<string, unknown>;
  PdvNextSoft?: Record<string, unknown>;
  PdvOXPI?: Record<string, unknown>;
  PdvOmie?: Record<string, unknown>;
  PdvProfig?: Record<string, unknown>;
  PdvSponte?: Record<string, unknown>;
  PdvTerasoft?: Record<string, unknown>;
  PdvUpdi?: Record<string, unknown>;
  PdvVarejoFacil: Record<string, unknown>;
  PdvVtex?: Record<string, unknown>;
  PdvWebPic?: Record<string, unknown>;
  Senha?: string;
  Timestamp?: string;
  Unika?: Record<string, unknown>;
  UpdatedAt?: string;
  ValoremPay?: Record<string, unknown>;
  ValoriBankApi?: Record<string, unknown>;
  WebhookF360Pdv?: Record<string, unknown>;
  Wirecard?: Record<string, unknown>;
  _id: string;
};

export type TIntegracaoDisplayRules = {
  DependsOnFieldId: string;
  Operator: string;
  Values: unknown[];
  VisibleWhenMatched: boolean;
  Source?: "FieldValue" | "SelectedOptionAttribute" | null;
  Attribute?: string | null;
  Aggregation?: "Any" | "All" | null;
};

export type TIntegracaoEndpointOpcao = {
  value: string;
  label: string;
  attributes?: Record<string, unknown> | null;
};

export type TIntegracaoEndpointParameterRef = {
  CampoId?: string;
  Valor?: unknown;
};

export type TIntegracaoEndpointParameters = Record<
  string,
  TIntegracaoEndpointParameterRef
>;

export type TIntegracaoActionPayloadTransform =
  | "First"
  | "WrapArray"
  | "SplitCsv"
  | "SplitCsvNumber";

export type TIntegracaoActionPayloadRef = {
  CampoId?: string;
  Valor?: unknown;
  Context?: string;
  Transform?: TIntegracaoActionPayloadTransform | null;
};

export type TIntegracaoActionPayloadNode =
  | TIntegracaoActionPayloadRef
  | { [key: string]: TIntegracaoActionPayloadNode };

export type TIntegracaoActionTemplateParameterRef = {
  CampoId?: string;
  Valor?: unknown;
};

export type TIntegracaoActionSetField = {
  CampoId: string;
  Valor: unknown;
};

export type TIntegracaoActionOutcome = {
  message?: string | null;
  messageField?: string | null;
  setFields?: TIntegracaoActionSetField[] | null;
  secretDialog?: TIntegracaoActionSecretDialog | null;
};

export type TIntegracaoActionConfirm = {
  message?: string | null;
  title?: string | null;
  confirmButtonText?: string | null;
  cancelButtonText?: string | null;
};

export type TIntegracaoActionSecretDialog = {
  title?: string | null;
  message?: string | null;
  valueLabel?: string | null;
  valueField: string;
};

export type TIntegracaoActionOpenUrl = {
  template?: string | null;
  parameters?: Record<string, TIntegracaoActionTemplateParameterRef> | null;
  target?: string | null;
  features?: string | null;
};

export type TIntegracaoActionPostAction = {
  type?: string | null;
};

export type TIntegracaoAction = {
  type?: string | null;
  variant?: "primary" | "danger" | "success" | "warning" | "neutral" | null;
  method?: string | null;
  endpoint?: string | null;
  host?: string | null;
  payload?: Record<string, TIntegracaoActionPayloadNode> | null;
  enableWhen?: string[] | null;
  confirm?: TIntegracaoActionConfirm | null;
  openUrl?: TIntegracaoActionOpenUrl | null;
  postAction?: TIntegracaoActionPostAction | null;
  payloadStrategy?: "legacy" | "legacyMultipart" | null;
  resultStrategy?: string | null;
  message?: string | null;
  when?: {
    fieldId: string;
    operator?: string | null;
    values?: unknown[] | null;
  } | null;
  then?: TIntegracaoAction | null;
  else?: TIntegracaoAction | null;
  result?: {
    success?: TIntegracaoActionOutcome | null;
    error?: TIntegracaoActionOutcome | null;
  } | null;
};

export type TIntegracaoRemoteCollectionColumn = {
  Key: string;
  Header: string;
};

export type TIntegracaoRemoteCollection = {
  TriggerLabel: string;
  IdKey: string;
  LabelKey: string;
  CheckedKey: string;
  PreserveSelectionBy: string;
  Columns: TIntegracaoRemoteCollectionColumn[];
  EmptyStateHint?: string | null;
  InfoHint?: string[] | null;
};

export type TIntegracaoPorIdCampo = {
  campoId: string;
  label: string;
  tipo: string;
  obrigatorio: boolean;
  criptografado: boolean;
  mascara: string | null;
  descricao: string | null;
  grupo: string | null;
  nomeObjetoNoLegado: string;
  payloadTransform?: TIntegracaoActionPayloadTransform | null;
  includeInPayload?: boolean;
  opcoes?:
    | {
        valor: string;
        texto: string;
        categoria?: string | null;
        attributes?: Record<string, unknown> | null;
      }[]
    | null;
  validacao?:
    | string
    | { campoId?: string | null; CampoId?: string | null }
    | null;
  limiteCaracteres: number | null;
  minLength?: number | null;
  fieldSize: string | null;
  placeholder: string | null;
  hint?: string[] | null;
  displayRules: TIntegracaoDisplayRules | null;
  requiredRules?: TIntegracaoDisplayRules | null;
  ordemDeExibicao: number;
  valorPadrao: unknown;
  visivel: boolean;
  desabilitado?: boolean;
  endpoint: string | null;
  endpointParameters?: TIntegracaoEndpointParameters | null;
  action?: TIntegracaoAction | null;
  remoteCollection?: TIntegracaoRemoteCollection | null;
  refetchDefinitionParameter?: string | null;
  value?: unknown[];
  hasPersistedValue?: boolean;
};

export type TObterIntegracaoPorIdResponse = {
  _id: string;
  api: number;
  nome: string;
  descricao: string;
  ativo: boolean;
  campos: TIntegracaoPorIdCampo[];
  submitAction?: TIntegracaoAction | null;
  editAction?: TIntegracaoAction | null;
};

export type TObterWebserviceParaEdicaoResponse =
  TObterIntegracaoPorIdResponse & {
    campos: TIntegracaoPorIdCampo[];
  };

export interface CadastroDeIntegracaoGateway {
  obterIntegracaoPorId(
    apiHash: EIntegracoesAPIEnum,
    queryParams?: Record<string, string>
  ): Promise<
    IDefaultHttpFinancasResponse<TObterIntegracaoPorIdResponse> | undefined
  >;
  obterMunicipiosOpt(): Promise<
    IDefaultHttpFinancasResponse<TKeyValue[]> | undefined
  >;
  obterEmpresasParaNexaas(): Promise<
    IDefaultHttpFinancasResponse<TKeyValue[]> | undefined
  >;
  getWebservice(
    id: string
  ): Promise<
    IDefaultHttpFinancasResponse<TObterWebserviceResponse> | undefined
  >;
  getWebserviceForEdit(
    id: string
  ): Promise<
    IDefaultHttpFinancasResponse<TObterWebserviceParaEdicaoResponse> | undefined
  >;
  executarAcaoCampo(
    metodo: string,
    endpoint: string,
    payload: Record<string, unknown>,
    host?: string | null
  ): Promise<IDefaultHttpFinancasResponse<unknown> | undefined>;
  saveWebservice(
    payload: Record<string, unknown>
  ): Promise<IDefaultHttpFinancasResponse<unknown> | undefined>;
  executarAcaoMultipart(
    metodo: string,
    endpoint: string,
    payload: FormData,
    host?: string | null
  ): Promise<IDefaultHttpFinancasResponse<unknown> | undefined>;
  editWebservice(
    payload: Record<string, unknown>
  ): Promise<IDefaultHttpFinancasResponse<unknown> | undefined>;
  obterOpcoesPorEndpoint(
    endpoint: string
  ): Promise<
    IDefaultHttpFinancasResponse<TIntegracaoEndpointOpcao[]> | undefined
  >;
}

export const CadastroDeIntegracaoDi = Symbol("CadastroDeIntegracaoDi");
